import connector from 'api/http';
import { makeApiError } from 'scenes/common/helpers/apiData';
import { ApiData, InsuranceName } from 'scenes/common/types';
import config from 'shared/config';

import { marshalRequest, unmarshalResponse } from './marshaller';
import { EstimatedSumInsuredProfile, EstimatedSumInsured } from './types';

const estimatedSumInsuredApi = (
  baseUrl: string = config.baseUrls.BFF_BASE_URL
) => {
  const server = connector(baseUrl);

  return {
    estimateSumInsured: (
      insuranceName: InsuranceName,
      estimatedSumInsuredProfile: EstimatedSumInsuredProfile
    ): Promise<ApiData<EstimatedSumInsured>> =>
      Promise.resolve()
        .then(() => marshalRequest(insuranceName, estimatedSumInsuredProfile))
        .then((request) => server.post('/quote/estimatedsi', request))
        .then(unmarshalResponse)
        .catch((err) => makeApiError(err.message)),
  };
};

export default estimatedSumInsuredApi;
